export type PopsContentInfo = { [key: string]: string[] };

export const defaultPopsCommentName = '__comment__';

export type PopsError = { message: string };

export type PopsProfile = {
  name: string;
  description: string;
};

export type PopsAdditionalInfo = {
  name: string;
  type: string;
  display: string;
  required: boolean;
  profiles: string[];
  values: Array<{
    name: string;
    description: string;
  }>;
};
